function requireComponent(name) {
  return import('./component/' + name + '.js');
}

window.requireComponent = requireComponent;
